import { CrowflightMap, type MapPoint } from "./CrowflightMap.js";
import styles from "./HintMapOverlay.module.css";

export interface HintMapOverlayProps {
  place: MapPoint;
  lang: "de" | "en";
  onClose: () => void;
  closeLabel: string;
}

/** Full-screen map overlay for the "give hint" feature — shows just the one
    place, dismissed manually (not auto-timed, unlike RoundIntroOverlay). */
export function HintMapOverlay({ place, lang, onClose, closeLabel }: HintMapOverlayProps) {
  return (
    <div className={styles.overlay} role="dialog" aria-modal="true" onClick={onClose}>
      <div className={styles.card} onClick={(e) => e.stopPropagation()}>
        <p className={styles.placeName}>{place.name}</p>
        <CrowflightMap points={[place]} mode="latitude" lang={lang} />
        <button type="button" className={styles.closeButton} onClick={onClose}>
          {closeLabel}
        </button>
      </div>
    </div>
  );
}
